import { render, staticRenderFns } from "./personal-information.page.vue?vue&type=template&id=e013be88&scoped=true&"
import script from "./personal-information.page.vue?vue&type=script&lang=js&"
export * from "./personal-information.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e013be88",
  null
  
)

export default component.exports